const CONTAINS_DIGIT = /\d/;
const CONTAINS_SPECIAL_CHARACTER = /[\@\#\$\%\^\&\*\-\!\_\?\.\,]/;
const CONTAINS_UPPER_CHARACTER = /[A-Z]/;
const PASSWORD_MIN_SIZE = 8;

export default (value) => {
  if (value && value.length < PASSWORD_MIN_SIZE) {
    return `requires at least ${PASSWORD_MIN_SIZE} characters.`;
  } else if (value && !CONTAINS_DIGIT.test(value)) {
    return 'requires digit.';
  } else if (value && !CONTAINS_SPECIAL_CHARACTER.test(value)) {
    return 'requires special symbols.';
  } else if (value && !CONTAINS_UPPER_CHARACTER.test(value)) {
    return 'requires upper case letters.';
  }
};



// WEBPACK FOOTER //
// ./src/utilites/validate/password.js